import { h, Fragment } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Alert,
	Box,
	Chip,
	Grid,
	Paper,
	Stack,
	Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BackButton from "../Common/BackButton";

import { AppContext } from "../../AppContext";



export default function UserDataroom({ id, pnl, cat, ...rest }) {
	//console.log("UserDataroom", rest);
	const [expanded, setExpanded] = useState(false);
	const app = useContext(AppContext);
	const [values, setValues] = useState(undefined);
	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};


	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dataroom/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setValues({ ...res.pld.dr, phdo: res.pld.phdo, peredo: res.pld.peredo });

						break;
					case "err":
						break;
					default:
						break;
				}
			});

		if (pnl !== undefined) {
			//	console.log("set panel to", pnl);
			setExpanded(pnl);
		}
	}, []);
	if (values === undefined) return;
	useEffect(() => {
		console.log("values", values)
		if (values.phdo === 1) {
			app.refPopUp.current.handleChangeState(
				{ opened: true, type: "036", params: { uid: id, type: values.role } }
			)
		}
		if (values.peredo === 1) {
			app.refPopUp.current.handleChangeState(
				{ opened: true, type: "037", params: { uid: id, type: values.role } }
			)
		}
	}, [values]);

	return (

		<Grid container>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Paper style="padding: 10px;">
							<Box display="flex" justifyContent="space-between" alignItems="center">
								<Box>
									<BackButton tooltip={"Revenir au dossier"} from={(values.role == "AM"
										? "/7bac6cb9d6ee4d70b1315393725f3a34/" + id
										: (values.role == "VN" || values.role == "VNP")
											? "/11d1355181ac4376a09980601b420617/" + id
											: (values.role == "AC" || values.role == "ACP")
												? "/1fdf58e512f54752959b369588380557/" + id : "/login")
									} />

								</Box>
								<Box>
									<Typography variant="h5" >
										Documents du dossier de vente
									</Typography>
								</Box>
								<Box></Box>
							</Box>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						{values.deal && (
							<Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
									<Typography variant="h5">Documents officiels</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<Grid container spacing={1}>
										{values.deal.de.map((doc) => {
											return <Grid item sm={3} xs={6}>
												<FileSlot doc={doc} cl={values.cl} panel={expanded} upld={false} />
											</Grid>;
										})}
									</Grid>
								</AccordionDetails>
							</Accordion>
						)}
						{values && values.re && (
							<Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4bh-content" id="panel4bh-header">
									<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
										<Box p={1} >
											<Typography variant="h5">Bien{values.re.re.length > 1 ? "s" : ""}</Typography>
										</Box >
										<Box p={1} sx={{ flexGrow: 1 }}>
											{values.re.docs_ok && <Chip
												size="small"
												color="success"
												label={`Complet${values.re.re.length > 1 ? "s" : ""}`}
											/>}
											{!values.re.docs_ok && <Chip
												size="small"
												color="warning"
												label={`Incomplet${values.re.re.length > 1 ? "s" : ""}`}
											/>}
										</Box>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{values &&
										values.re && values.re.re &&
										values.re.re.map((re) => {
											return (
												<Stack spacing={1}>

													<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
														<Box p={1} >
															<Typography variant="h5" style="margin-bottom: 10px;">{re.hd}</Typography>
														</Box >
														<Box p={1} sx={{ flexGrow: 1 }}>
															{re.docs && <Paper style={{ marginBottom: "10px" }}>
																<Alert severity="success" >
																	Vous avez rempli toutes les informations
																</Alert>
															</Paper>}
														</Box>
													</Box>

													<Grid container spacing={1}>
														{re.de.map((doc) => {
															return (
																<Grid item sm={3} xs={6}>
																	<FileSlot
																		doc={doc}
																		cl={values.cl}
																		panel={expanded}
																		id={id}
																		upld={values.role == "VNP"}
																	/>
																</Grid>
															);
														})}
													</Grid>
												</Stack>
											);
										})}
								</AccordionDetails>
							</Accordion>
						)}
						{values && values.vn && (
							<Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">

									<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
										<Box p={1} >
											<Typography variant="h5">Vendeur{values.vn.vn.length > 1 ? "s" : ""}</Typography>
										</Box >
										<Box p={1} sx={{ flexGrow: 1 }}>
											{values.vn.docs_ok && <Chip
												size="small"
												color="success"
												label={`Complet${values.vn.vn.length > 1 ? "s" : ""}`}
											/>}
											{!values.vn.docs_ok && <Chip
												size="small"
												color="warning"
												label={`Incomplet${values.vn.vn.length > 1 ? "s" : ""}`}
											/>}
										</Box>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									<Stack spacing={1}>
										{values.vn && values.vn.vn && values.vn.vn.map((vn) => {
											return (
												<Stack spacing={0.5}>
													<Typography variant="h5">Liste des documents pour {vn.hd}</Typography>
													{values.vn.vn.length > 1 && vn.docs && <Paper style={{ marginBottom: "10px" }}>
														<Alert severity="success" >
															Vous avez rempli toutes les informations
														</Alert>
													</Paper>}
													<Grid container spacing={1}>
														{vn.de.map((doc) => {
															return (
																<Grid item sm={3} xs={6}>
																	<FileSlot
																		doc={doc}
																		cl={values.cl}
																		panel={expanded}
																		id={id}
																		upld={(values.role == "VN" || values.role == "VNP")}
																	/>
																</Grid>
															);
														})}
													</Grid>
												</Stack>
											);
										})}
									</Stack>
								</AccordionDetails>
							</Accordion>
						)}
						{values && values.aq && (
							<Accordion expanded={expanded === "panel3" || values.aq.aq.length === 1} onChange={handleChange("panel3")}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">

									<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
										<Box p={1} >
											<Typography variant="h5">Acquéreur{values.aq.aq.length > 1 ? "s" : ""}</Typography>
										</Box >
										<Box p={1} sx={{ flexGrow: 1 }}>
											{values.aq.docs_ok && <Chip
												size="small"
												color="success"
												label={`Complet${values.aq.aq.length > 1 ? "s" : ""}`}
											/>}
											{!values.aq.docs_ok && <Chip
												size="small"
												color="warning"
												label={`Incomplet${values.aq.aq.length > 1 ? "s" : ""}`}
											/>}
										</Box>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									<Stack spacing={1}>
										{values &&
											values.aq && values.aq.aq &&
											values.aq.aq.map((aq) => {
												return (
													<Stack spacing={0.5}>
														<Typography variant="h5">Liste des documents pour {aq.hd}</Typography>
														{values.aq.aq.length > 1 && aq.docs && <Paper style={{ marginBottom: "10px" }}>
															<Alert severity="success" >
																Vous avez rempli toutes les informations
															</Alert>
														</Paper>}
														<Grid container spacing={1}>
															{aq.de.map((doc) => {
																return (
																	<Grid item sm={3} xs={6}>
																		<FileSlot
																			doc={doc}
																			cl={values.cl}
																			panel={expanded}
																			id={id}
																			upld={(values.role == "AC" || values.role == "ACP")}
																		/>
																	</Grid>
																);
															})}
														</Grid>
													</Stack>
												);
											})}
									</Stack>
								</AccordionDetails>
							</Accordion>
						)}
					</Grid>{" "}
				</Grid>
			</Grid>
		</Grid>

	);
}

function FileSlot({ doc, cl, panel, id, upld }) {
	//console.log("FileSlot", doc, cl);
	const app = useContext(AppContext);
	return (
		<Paper
			style="padding: 5px; background-color: rgba(244, 246, 248, 0.81); cursor: pointer; height: 100%;"
			onClick={() => app.refPopUp.current.handleChangeState(
				{
					opened: true,
					type: "033",
					params: {
						doc: doc,
						cat: cl[doc.c].nm,
						h: cl[doc.c].ph,
						u: "U",
						panel: panel,
						id: id,
						upld: upld
					}
				})}
		>
			<Stack spacing={1} alignItems={"center"} justifyContent={"space-between"} style="height: 100%">
				<Typography variant="h5" style="text-align: center;" >
					{cl[doc.c].nm}
				</Typography>
				<Box display={"flex"} justifyContent={"center"} alignItems="flex-end" >
					<Box >
						<Stack spacing={1} alignItems={"center"} justifyContent={"center"} >
							<Chip
								size="small"
								color={doc.inm ? "info" : "primary"}
								label={doc.inm ? "Facultatif" : "Obligatoire"}
							/>
							<Typography variant="body2" >
								<Chip
									size="small"
									color={doc.r.length > 0 ? "success" : doc.inm ? "default" : "error"}
									label={doc.r.length > 0 ? `${doc.r.length} document${doc.r.length > 1 ? "s" : ""}` : <em>Pas&nbsp;de&nbsp;document</em>}
								/>

							</Typography>
						</Stack>
					</Box>
				</Box>
			</Stack>
		</Paper >
	);
}
